import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TradingState } from "./tradingTypes";

const initialState: TradingState = {
  pricingFormat: "default",
};

const uiSlice = createSlice({
  name: "trading",
  initialState,
  reducers: {
    setPricingFormat: (
      state,
      action: PayloadAction<"default" | "millions">
    ) => {
      state.pricingFormat = action.payload;
    },
    clearPricingFormat: (state) => {
      state.pricingFormat = "default";
    },
    clearUi: (state) => {
      state.pricingFormat = "default";
    },
  },
});

export const { setPricingFormat, clearPricingFormat, clearUi } =
  uiSlice.actions;

export default uiSlice.reducer;
